import "../../shared/sparkle_namespace.js";
import "./badges/queue_length_badge.js";
import "./badges/wait_time_badge.js";

window.Sparkle ??= {};

// Merged onto the existing namespace, never replaced: the badge modules
// above attach WaitTimeBadge / QueueLengthBadge before this body runs.
Sparkle.WalkInAvailability = Object.assign(window.Sparkle.WalkInAvailability ?? {}, {
  endpointUrl: window.SparkleConfig?.routes?.walkInAvailabilities,
  staleTimeout: 5000,
  updateInterval: 60000,
  observers: {},
  states: {},

  // DSL

  observe(resourceKey, callback) {
    this.observers[resourceKey] = this.observers[resourceKey] || [];
    this.observers[resourceKey].push(callback);
    if (this.states[resourceKey]) {
      callback(this.states[resourceKey]);
    } // Immediately update the observer if we have a cached state
    return this.start();
  },

  // PRIVATE

  start() {
    if (this.started) {
      return;
    }
    this.started = true;

    // Wait until we init all the walk-in badges instead of just requesting the first one on the page and having to wait
    // for the next fetch to request others
    $(() => this.updateState().done(() => this.refreshIfStale()));

    return this.liveUpdateState();
  },

  liveUpdateState() {
    const callback = () => this.updateState();
    return setInterval(callback, this.updateInterval);
  },

  refreshIfStale() {
    let updateAgain = false;
    jQuery.each(this.states, (_, state) => {
      if (state.stale) {
        return (updateAgain = true);
      }
    });

    // Update again soon if the data was stale
    if (updateAgain) {
      return setTimeout(() => this.updateState(), this.staleTimeout);
    }
  },

  updateState() {
    return this.fetchState().done((states) => {
      this.states = states;
      return jQuery.each(this.states, (key, state) => this.notifyObservers(key, state));
    });
  },

  notifyObservers(key, state) {
    return jQuery.each(this.observers[key], (_, callback) => callback(state));
  },

  fetchState() {
    return jQuery.get(this.endpointUrl, { resources: Object.keys(this.observers) }, "json");
  },
});
